import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { CheckInProgramRetrieve, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export interface UpdateCommittedClubProgramPayload {
  checkInProgramId: string;
  name: string;
  currentThreshold: number;
  athleteVisibilityEnabled: boolean;
}

export default function useUpdateCommittedClubProgram(): UseMutationResult<
  AxiosResponse<CheckInProgramRetrieve>,
  AxiosError<ErrorMessage>,
  UpdateCommittedClubProgramPayload
> {
  const queryClient = useQueryClient();

  const updateProgram = ({
    checkInProgramId,
    ...payload
  }: UpdateCommittedClubProgramPayload): Promise<AxiosResponse<CheckInProgramRetrieve>> =>
    client.put(`check-in-program/program/${checkInProgramId}/`, payload);

  return useMutation(updateProgram, {
    onSuccess: () => {
      queryClient.invalidateQueries('committedClubProgram');
    },
  });
}
